import React from "react";
import style from "css/admin/component.module.css";

function SearchButton({ children, onClick, className = "", disabled = false, ...rest }) {
    return (
        <button
            type="button"
            className={`${style.appButton} ${className}`}
            onClick={onClick}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
}

export default SearchButton;

